import { call, fork, put, select, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Functions
import { functions } from "./../firebase";
import poll from "../util/pollData";
import * as UTIL from "./../pages/util";

//Selectors
import { getApiKey, getSiteId } from "./selectors";

function* pollFn(apiKey, siteId) {
  const fetchData = functions.httpsCallable("fetchData");
  const data = yield fetchData({ siteId, apiKey }).then(result => {
    console.log(result, " from forked saga");
    return JSON.parse(result.data);
  });
  const normalizedData = UTIL.dataNormalizer(data);
  yield put({ type: ACTIONS.STORE_DATA, payload: normalizedData });
}

function* handleChangeSetpoint(action) {
  const apiKey = yield select(getApiKey);
  const siteId = yield select(getSiteId);

  const { buildingName, objectInstance, value } = action.payload;
  const siteData = { apiKey, buildingName, objectInstance, value };

  if (apiKey) {
    try {
      //Use callable function
      const changeSetpoint = functions.httpsCallable("changeSetpoint");
      // eslint-disable-next-line
      const data = yield changeSetpoint({ ...siteData }).then(result => {
        console.log(result);
      });

      const pollCall = yield fork(poll, pollFn, 100000, 2000);
      console.log(pollCall);
    } catch (err) {
      console.log(err);
    }
  } else {
    return null;
  }
}

export function* changeSetpoint() {
  yield takeEvery(ACTIONS.CHANGE_SETPOINT, handleChangeSetpoint);
}



// WEBPACK FOOTER //
// ./src/sagas/changeSetpoint.js